import {
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

// const DEFAULT_CHART_SIZE = { width: 76, height: 45 };
const CHART_MARGIN = { top: 2, right: 0, bottom: 2, left: 0 };
const VERTICAL_PAD = 5;

const toChartSeries = (data) => {
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;

  return data.map((value, index) => ({
    index,
    value:
      VERTICAL_PAD +
      ((value - min) / range) * (100 - VERTICAL_PAD * 2),
  }));
};

const Sparkline = ({ data, color, width = 76, height = 45 }) => {
  // Extract array if passed as sparkline_in_7d object, or fallback to raw array
  const rawPrices = Array.isArray(data) ? data : data?.price;

  if (!rawPrices?.length) return null;

  const containerStyle =
    width === "100%"
      ? { width: "100%", height }
      : { width, height };

  return (
    <div
      className="shrink-0 overflow-visible"
      style={containerStyle}
      aria-hidden
    >
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={toChartSeries(rawPrices)} margin={CHART_MARGIN}>
          <XAxis hide dataKey="index" type="number" domain={["dataMin", "dataMax"]} />
          <YAxis hide domain={[0, 100]} />
          <Line
            type="linear"
            dataKey="value"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            dot={false}
            activeDot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Sparkline;